export default Navegacao;

/** @ngInject */
function Navegacao($state, $rootScope, STATE_DEFAULT, Usuario) {
  let historico = [];
  let backLogin;

  this.voltar = voltar;
  this.iniciar = iniciar;

  function iniciar() {
    $rootScope.$on('$stateChangeStart', stateChangeStart);
  }

  function voltar(login) {
    let state = (login ? backLogin : historico.pop()) || STATE_DEFAULT;

    if (typeof state[0] === 'object') {
      state[0].back = true;
    }

    $state.transitionTo(state[0], state[1]);
  }

  function stateChangeStart(event, toState, toParams, fromState, fromParams) {
    if (!toState.back && !fromState.abstract) {
      historico.push([fromState, fromParams]);
    }

    toState.back = false;

    let fretes = toState.name === 'consulta.fretes.listagem' && toParams.index === '0';
    let empresas = toState.name === 'consulta.empresas.listagem';

    if (fretes || empresas) {
      historico = [];
    }

    if (!Usuario.obterUsuario().nm_usuario && !toState.open) {
      backLogin = [toState, toParams];
      event.preventDefault();
      Usuario.dialog('Aviso', 'Para acessar este conteúdo você precisa realizar o login!');
      $state.go('consulta.usuario.login');
    }
  }
}



/** WEBPACK FOOTER **
 ** ./common/services/navegacao.service.ts
 **/